import React, {useEffect, useState} from 'react';

import styles from './MobileDeliveryByCompanies.module.css'
import {Button} from "../../../../../../../ui/General/Button/Button.tsx";
import {Checkbox} from "../../../../../../../ui/Filters/components/Checkbox/Checkbox.tsx";
import {Order} from "../../../../../../../types/Order.interface.ts";
import {
    DeliveryShippingAddress
} from "../../../components/DeliveryByCompanies/components/DeliveryShippingAddress/DeliveryShippingAddress.tsx";
import {Address} from "../../../../../../../types/Delivery.interface.ts";
import { RootState, useAppSelector } from '@/utils/storage/stores/store.ts';
// import { useMultiStorage } from '../../../../../../../hooks/useStorage.ts';

interface Props {
    onDeliveryTransportCompanyChange: (transportCompanyId: number) => void,
    onDeliveryAddressChange: (address: Address) => void,
}

export const MobileDeliveryByCompanies: React.FC<Props> = ({onDeliveryTransportCompanyChange, onDeliveryAddressChange, }) => {
    const [transportCompanyId, setTransportCompanyId] = useState<number>(0);
    const [offer, setOffer] = useState<Order|null>(null);
    const cartOffer = useAppSelector((state: RootState) => state.cart.cartOffer);
    // const storage = useMultiStorage({
    //     cartOffer: ['cartOffer', offer],
    //   })[0];

    const changeTransportCompany = (transportCompanyId: number) => {
        setTransportCompanyId(transportCompanyId);
        onDeliveryTransportCompanyChange(transportCompanyId);
    }

    useEffect(() => {
        if(cartOffer) {
            setOffer(cartOffer);
            setTransportCompanyId(cartOffer.delivery.company?.id || 0);
        }
    }, [cartOffer])

    if(!offer) return null;

    return (<>
        <div className={styles.wrapper}>
            <div className={styles.settings}>
                <h4>Выберите компанию</h4>
                <Button type='text'>
                    Изменить
                </Button>
            </div>
            <ul className={styles.offers}>
                {offer.delivery.offers.map(({id, name}) => (
                    <li className={styles.offer} onClick={() => changeTransportCompany(id)}>
                        <Checkbox viewType='radio' checked={transportCompanyId === id}/>
                        <div className={styles.name}>{name}</div>
                        <div className={styles.price}></div>
                        {/*<div className={styles.offerExtraInfo}>*/}
                        {/*    Посылка склад дверь*/}
                        {/*</div>*/}
                        <div className={styles.outline}/>
                    </li>))}
            </ul>
        </div>
        <div className={styles.address}>
            <DeliveryShippingAddress
                onAddressChange={onDeliveryAddressChange}
            />
        </div>
        </>);
};